import Vuex from 'vuex'
import { serverStore } from "./servers";
import { viewStore } from "./view";
import { treeStore } from "./tree";
import { RootState } from "./state";

export const createStore = () => new Vuex.Store<RootState>({
    modules: {
        serverStore,
        viewStore,
        treeStore
    },
});



// WEBPACK FOOTER //
// ./src/store/store.ts